export const concatPath = (...segments: string[]): string =>
  segments.map((segment) => segment.replace(/^\/+|\/+$/g, '')).join('/');
